module.exports = __webpack_public_path__ + "static/img/team.0b6554b2.png";